import { PagedSearch } from '../shared/model/paged-search.model';

export class ListingSubCategorySearchParams extends PagedSearch {
  public constructor() {
    super();
  }
}
